"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var context_1 = __importDefault(require("components/Money/context"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Loadable_1 = __importDefault(require("containers/NotFoundPage/Loadable"));
var FooterMaker_1 = __importDefault(require("containers/TableMaker/FooterMaker"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var backend_1 = require("utils/backend");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var context_2 = require("./context");
var CustomersSearchAndFilter_1 = __importDefault(require("./CustomersSearchAndFilter"));
var hooks_2 = require("./hooks");
var InvoicePreviewModal_1 = __importDefault(require("./Modals/InvoicePreviewModal"));
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var Header = (0, HeaderMaker_1.default)(tableConf_1.autoRechargingTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.autoRechargingTableConf);
var SubRow = (0, RowMaker_1.default)(tableConf_1.extendedRechargeTableConf);
var Footer = (0, FooterMaker_1.default)(tableConf_1.autoRechargingTableConf);
var FILTER_MAP = {
    // new: (rechOrg) => rechOrg.status === 'new',
    // charges: (rechOrg) => rechOrg.status === 'charges',
    // recharging: (rechOrg) => rechOrg.status === 'recharging',
    customers: function () { return true; },
};
var MONEY_CONTEXT_VAL = { fixedDecimals: true };
var AutomaticRecharging = function () {
    var _a = __read(react_1.default.useState(false), 2), openModal = _a[0], setOpenModal = _a[1];
    var _b = __read(react_1.default.useState(null), 2), openRowModal = _b[0], setOpenRowModal = _b[1];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var filterKey = (0, react_router_dom_1.useParams)().filterKey;
    var filterFunction = FILTER_MAP[filterKey];
    var customersToRecharge = (0, react_redux_1.useSelector)(populatedDerived_1.selectCustomersToRechargeWithRecharges);
    var _c = __read((0, utils_1.useFilterMapping)(customersToRecharge !== null && customersToRecharge !== void 0 ? customersToRecharge : []), 3), filteredCustomers = _c[0], searchProps = _c[1], filterProps = _c[2];
    var sortedCustomersToRecharge = (0, hooks_1.useSortArray)(filteredCustomers, tableConf_1.autoRechargingTableConf.extractors, undefined, tableConf_1.autoRechargingTableConf.sortMapper);
    var _d = __read((0, useInfiniteScroll_1.default)(sortedCustomersToRecharge || [], 50), 2), pagedCustomers = _d[0], loaderRef = _d[1];
    (0, hooks_2.useTriggerDetectTaxes)();
    var _e = __read((0, backend_1.useCall)('invoicing-makeinvoicesforaccfirm', { companyId: profile.companyId }), 2), makeInvoices = _e[0], isMakingInvoices = _e[1];
    var OpenModal = openRowModal && utils_1.MODALS_CONF[openRowModal.modalKey];
    var openModalItem = ((openRowModal === null || openRowModal === void 0 ? void 0 : openRowModal.itemId) && (customersToRecharge === null || customersToRecharge === void 0 ? void 0 : customersToRecharge.find(function (item) { return item.id === (openRowModal === null || openRowModal === void 0 ? void 0 : openRowModal.itemId); })))
        || (openRowModal === null || openRowModal === void 0 ? void 0 : openRowModal.item) || undefined;
    if (!filterFunction) {
        return (0, jsx_runtime_1.jsx)(Loadable_1.default, {});
    }
    if (!(0, react_redux_firebase_1.isLoaded)(customersToRecharge) || !sortedCustomersToRecharge) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var showInvoices = function () { return makeInvoices()().then(function () { return setOpenModal(true); }); };
    return ((0, jsx_runtime_1.jsxs)(context_1.default.Provider, __assign({ value: MONEY_CONTEXT_VAL }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 1.25 }, { children: (0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: constants_1.AUTO_RECHARGING_TABS }) })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ mb: 1.25, display: "flex", justifyContent: "flex-end", alignItems: "center", width: 1202, gap: 2 }, { children: [(0, jsx_runtime_1.jsx)(CustomersSearchAndFilter_1.default, __assign({ rechargedCustomers: customersToRecharge }, searchProps, filterProps)), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ onClick: showInvoices, isSending: isMakingInvoices }, { children: "Preview and Enable Recharging" }))] })), (0, jsx_runtime_1.jsx)(context_2.BillingModalContext.Provider, __assign({ value: setOpenRowModal }, { children: (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1375 }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsxs)(TableBody_1.default, { children: [pagedCustomers === null || pagedCustomers === void 0 ? void 0 : pagedCustomers.map(function (customer) { return ((0, jsx_runtime_1.jsx)(Row, __assign({ item: customer, expandable: true }, { children: customer.organizations.map(function (org) { var _a; return (_a = org.recharges) !== null && _a !== void 0 ? _a : []; }).flat().map(function (recharge) { return ((0, jsx_runtime_1.jsx)(SubRow, { item: recharge }, recharge.id)); }) }), customer.id)); }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef })] }), (0, jsx_runtime_1.jsx)(Footer, { items: filteredCustomers !== null && filteredCustomers !== void 0 ? filteredCustomers : [] })] })) })), (0, jsx_runtime_1.jsx)(InvoicePreviewModal_1.default, { open: openModal, onClose: function () { return setOpenModal(!openModal); } }), OpenModal && openModalItem && (0, jsx_runtime_1.jsx)(OpenModal, { item: openModalItem, onClose: function () { return setOpenRowModal(null); } })] })));
};
exports.default = (0, SortHoC_1.default)(AutomaticRecharging, { key: 'name', order: 1 });
